import { Button } from "@aurumiq/ui/components/button";
import { Upload } from "lucide-react";
import { useRef, useState } from "react";
import { useUploadMedia } from "./queries";

/** File input → upload-url → PUT (with progress) → finalise; alt derived from the filename. */
export function UploadButton() {
  const upload = useUploadMedia();
  const input = useRef<HTMLInputElement>(null);
  const [progress, setProgress] = useState<{ name: string; pct: number } | null>(null);

  const onFiles = async (files: FileList | null) => {
    if (!files?.length) return;
    for (const file of Array.from(files)) {
      setProgress({ name: file.name, pct: 0 });
      try {
        await upload.mutateAsync({
          file,
          alt: file.name.replace(/\.[a-z0-9]+$/i, "").replace(/[-_]+/g, " "),
          onProgress: (pct) => setProgress({ name: file.name, pct }),
        });
      } catch {
        // toast shown by the mutation
      }
    }
    setProgress(null);
    if (input.current) input.current.value = "";
  };

  return (
    <div className="flex items-center gap-3">
      <input
        ref={input}
        type="file"
        accept="image/*,video/*,.pdf"
        multiple
        className="sr-only"
        aria-label="Upload files"
        onChange={(e) => onFiles(e.target.files)}
      />
      <Button variant="gold" onClick={() => input.current?.click()} disabled={upload.isPending}>
        <Upload /> Upload
      </Button>
      {progress ? (
        <div className="grid min-w-48 gap-1 text-xs" aria-live="polite">
          <span className="truncate">
            {progress.name} · {progress.pct}%
          </span>
          <progress className="h-1.5 w-full" value={progress.pct} max={100} />
        </div>
      ) : null}
    </div>
  );
}
